import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import {
  Row,
  Col,
  Card,
  Button,
  Dropdown,
  InputGroup,
  Form,
  Table,
} from "react-bootstrap";
import {
  FaPlus,
  FaCog,
  FaFilter,
  FaRedo,
  FaSearch,
  FaSort,
  FaToggleOff,
  FaToggleOn,
  FaEdit,
  FaTrashAlt,
} from "react-icons/fa";
import {
  getMaintenanceList,
  updateMaintenanceStatus,
  deleteMaintenance,
} from "../../../services/OrganisationServices/transportManagemetService.js";
import { getMethods } from "../../../services/utilityFunctions";
import MasterTable from "../../../views/dashboard/widget/MasterTabel";
import AddMaintenanceForm from "../../FormComponents/AddMaintenanceForm";

import { useGlobalState } from "../../../services/hostelConst";

const TransportMaintenanceTable = () => {
  const { _advanceFilterList, updateAdvanceFilterList } = useGlobalState();

  useEffect(() => {
    updateAdvanceFilterList((prev) => {
      return {
        ...prev,
        date: true,
        status: true,
        region: true,
        site: true,
        department: true,
      };
    });
    return () => {};
  }, []);

  return (
    <>
      <MasterTable
        getTableData={getMaintenanceList}
        tab1={"Transport"}
        tab2={"Maintenance"}
        actions={{
          status: true,
          edit: true,
          delete: true,
        }}
        updateStatus={updateMaintenanceStatus}
        AddForm={AddMaintenanceForm}
        deleteRow={deleteMaintenance}
      />
    </>
  );
};

export default TransportMaintenanceTable;
